var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Restricted", { ref: "restrictedRef" }),
      _c("Risk", { ref: "riskRef" }),
      _c("Limits", { ref: "limitsRef" }),
      _c("PendingAccountNotice", { ref: "pendingRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }